module.exports = __webpack_public_path__ + "01_very_short_yellow.635e1817.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_very_short_yellow.png
// module id = VjO7
// module chunks = 0